import api from './authService'; // Assuming authService exports the axios instance configured with interceptors

export const nocService = {
    getAll: (page = 1, limit = 10, status = '') => {
        let url = `/noc/requests?page=${page}&limit=${limit}`;
        if (status && status !== 'all') {
            url += `&status=${status}`;
        }
        return api.get(url);
    },

    uploadDocument: (requestId: string, file: File) => {
        const formData = new FormData();
        formData.append('document', file);
        return api.post(`/noc/requests/${requestId}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};
